import { startCase } from 'lodash-es';

import { EnclaveType } from '../types/enclave';
import { SourceType } from '../types/source';

type SourceTypeMapper = {
  [key in EnclaveType]?: SourceType;
};

const SOURCE_TYPE_MAPPER: SourceTypeMapper = {
  [EnclaveType.CLOSED_CONCRETE]: SourceType.PREMIUM_INTELLIGENCE,
  [EnclaveType.INTERNAL]: SourceType.INTERNAL,
  [EnclaveType.OPEN]: SourceType.OPEN_SOURCE_INTELLIGENCE,
  [EnclaveType.OTHER]: SourceType.OTHER,
};

/**
 * Maps an old source type to one of the newest ones and return it.
 */
export const getSourceType = (sourceLabel?: EnclaveType) => {
  const mappedType = sourceLabel ? SOURCE_TYPE_MAPPER[sourceLabel] : undefined;

  if (mappedType) {
    return startCase(mappedType.toLowerCase());
  }

  return '-';
};
